// extracted by mini-css-extract-plugin
module.exports = {"contentWidthYoutube":"contentWidthYoutube-module___C4Ahq__contentWidthYoutube"};